export enum PropertyStatus {
  DRAFT = 'Draft',
  READY_FOR_LISTING = 'Ready for listing',
  LISTING_IN_PROGRESS = 'Listing in progress',
  LISTED = 'Listed',
  UNLISTED = 'Unlisted',
  RENTED_OUT = 'Rented out',
}
